import { gql } from 'graphql-request';
import { EventData, EventType } from './HeroSection.types';
import { joyAllEventTypes } from './HeroSection.utils';
import { useGraphQLClient } from '@utils/graphql/useGraphQLClient';

type FindACoupleApiResponse = {
  getEventsBySearch: { results: EventData[]; totalCount: number };
};

export const useFindACoupleGQLQuery = () => {
  const client = useGraphQLClient();

  const fetchData = async (coupleNames: string, eventTypes?: EventType[]) => {
    const query = gql`
      query FINDACOUPLE($coupleNames: String!, $eventTypes: [EventType!]!) {
        getEventsBySearch(criteria: { coupleNames: $coupleNames, eventTypes: $eventTypes }) {
          totalCount
          resultCount
          results {
            event {
              firebaseId
              website
              photo {
                url
              }
              domain {
                id
                domainName
              }
              activeSession {
                hasUnlocked
                canAccessPage(type: registry)
              }
              pageInfo(type: registry) {
                disabled
              }
              info {
                eventType
                ownerFullName
                fianceeFullName
                tentativeDate {
                  timestamp
                }
                dateV0918 {
                  timestamp
                }
                finalizedDate {
                  timestamp
                }
              }
            }
          }
        }
      }
    `;

    const variables = { coupleNames: coupleNames, eventTypes: eventTypes ?? joyAllEventTypes };
    const response = await client.request<FindACoupleApiResponse>(query, variables);
    return response;
  };

  return {
    fetchData,
  };
};
